import type { FC } from "react";

interface D100IconProps {
  className?: string;
}

export const D100Icon: FC<D100IconProps> = ({ className }) => (
  <svg
    className={className}
    width="45"
    height="33"
    viewBox="0 0 45 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1406 0.554688C16.8281 0.179688 16.3906 -0.0078125 16.0156 -0.0078125C15.5781 -0.0078125 15.1406 0.179688 14.8906 0.554688L0.390625 17.0547C0.078125 17.3047 -0.046875 17.7422 0.015625 18.1172C0.015625 18.4922 0.203125 18.8672 0.515625 19.1797L15.0156 31.6797C15.5781 32.1172 16.3906 32.1172 16.9531 31.6797L31.4531 19.1797C31.7656 18.8672 31.9531 18.5547 31.9531 18.1172C32.0156 17.7422 31.8906 17.3047 31.6406 17.0547L17.1406 0.554688ZM3.45312 16.5547L13.3281 5.30469L9.26562 15.1797L3.45312 16.5547ZM15.0156 28.9922L3.01562 18.6797L9.76562 17.1172L15.0156 20.5547V28.9922ZM28.9531 18.6797L17.0156 28.9922V20.5547L22.2031 17.1172L28.9531 18.6797ZM18.6406 5.30469L28.5156 16.5547L22.7031 15.1797L18.6406 5.30469ZM20.7656 15.6172L16.0156 18.8047L11.2031 15.6172L16.0156 4.11719L20.7656 15.6172Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.1712 17.125L33.9668 17.9231C33.9651 17.2348 33.7494 16.506 33.2934 15.9205L33.7337 15.625L28.9837 4.125L27.0316 8.78987L25.5563 7.1111L26.2962 5.3125L25.1366 6.63355L23.8301 5.1468L27.8587 0.5625C28.1087 0.1875 28.5462 0 28.9837 0C29.3587 0 29.7962 0.1875 30.1087 0.5625L44.6087 17.0625C44.8587 17.3125 44.9837 17.75 44.9212 18.125C44.9212 18.5625 44.7337 18.875 44.4212 19.1875L29.9212 31.6875C29.3587 32.125 28.5462 32.125 27.9837 31.6875L23.9991 28.2525L25.5541 26.912L27.9837 29V24.8175L29.9837 23.0933V29L41.9212 18.6875L35.1712 17.125ZM41.4837 16.5625L31.6087 5.3125L35.6712 15.1875L41.4837 16.5625Z"
    />
  </svg>
);
